import type { SessionSummary } from '@/api/types';
import type { PinnedItem } from './SidebarRail';

const RECENTS_LIMIT = 8;

const interactionTime = (s: SessionSummary): number =>
  s.last_interaction_at?.valueOf() ?? new Date(s.created_at).valueOf();

const toItem = (s: SessionSummary, activeId: string | null): PinnedItem => ({
  name: s.title || 'Untitled',
  iconSvg: s.title_icon_svg ?? null,
  href: `/agent/${s.id}`,
  sessionId: s.id,
  on: s.runtime_status === 'on' || !!s.active_run_id,
  active: s.id === activeId,
});

export const sessionsToRailItems = (
  sessions: SessionSummary[],
  activeSessionId: string | null = null,
): { pinned: PinnedItem[]; recents: PinnedItem[] } => {
  const sorted = [...sessions].sort((a, b) => interactionTime(b) - interactionTime(a));
  const pinnedSrc = sorted.filter((s) => s.pinned);
  const unpinnedSrc = sorted.filter((s) => !s.pinned);

  // If the active session is unpinned, hoist it to the top of recents so
  // the highlighted row stays anchored at the top regardless of when the
  // server last bumped its last_interaction_at.
  if (activeSessionId) {
    const idx = unpinnedSrc.findIndex((s) => s.id === activeSessionId);
    if (idx > 0) {
      const [active] = unpinnedSrc.splice(idx, 1);
      unpinnedSrc.unshift(active);
    }
  }

  return {
    pinned: pinnedSrc.map((s) => toItem(s, activeSessionId)),
    recents: unpinnedSrc.slice(0, RECENTS_LIMIT).map((s) => toItem(s, activeSessionId)),
  };
};
